export enum SelectionStepsIndexEnum {
  LOT = 0,
  BUILDER = 1,
  HOUSE = 2,
  FACADES = 3,
  CONFIRMATION = 4,
}
